<template>
    <select :id="cid" :name="name"
            :class="classes"
            v-on:change="onChange"
            :aria-invalid="invalid"
            :aria-required="mandatory">
        <option value="" v-if="placeholder" :aria-label="placeholder" v-text="mandatory ? placeholder + ' *' : placeholder"></option>
        <option :value="code" v-for="(displayName,code) in options"
                :selected="code===selected"
                :key="name + '_option_' + code" v-text="displayName">
        </option>
    </select>
</template>

<script>
import { mixin } from '../js/ciam-mixin.js'

export default {
  mixins: [mixin],
  props: {
    id: String,
    name: String,
    placeholder: String,
    selected: {
      type: String,
      default: null
    },
    // this must be an key-value object/map with the following format:
    // { "value1": "some text", "value2": "<p> text2</p>", "key3": "<p> text2</p>" }
    options: {
      type: Object,
      required: true
    },
    classes: {
      type: String,
      default: 'ui fluid search dropdown'
    },
    mandatory: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      cid: this.id ? this.id : 'drop' + Date.now()
    }
  },
  model: {
    prop: 'selected',
    event: 'change'
  },
  methods: {
    onChange: function ($event) {
      if (this.selected !== $event.target.value) {
        this.$emit('change', $event.target.value)
      }
    }
  }
}
</script>

<style scoped>
</style>
